// Extract a YouTube video ID from a full URL or a raw ID.
export function youTubeId(input) {
  if (!input) return "";
  const s = String(input).trim();
  // already looks like a bare ID
  if (/^[a-zA-Z0-9_-]{11}$/.test(s)) return s;
  const patterns = [
    /(?:youtube\.com\/watch\?[^#]*v=)([a-zA-Z0-9_-]{11})/,
    /(?:youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    /(?:youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/,
    /(?:youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/,
    /(?:youtube\.com\/live\/)([a-zA-Z0-9_-]{11})/,
    /[?&]v=([a-zA-Z0-9_-]{11})/,
  ];
  for (const re of patterns) {
    const m = s.match(re);
    if (m && m[1]) return m[1];
  }
  return "";
}

export function youTubeEmbed(input) {
  const id = youTubeId(input);
  return id ? `https://www.youtube-nocookie.com/embed/${id}?rel=0&modestbranding=1` : "";
}

export function youTubeWatch(input) {
  const id = youTubeId(input);
  return id ? `https://www.youtube.com/watch?v=${id}` : (input || "");
}
